/**
 * <s-quote-slider> — swipeable testimonial row with previous/next buttons.
 *
 * The track is a native scroll-snap container ([data-slider-track]); buttons only scroll it
 * by one card. Buttons disable at either end.
 *
 * Commands (on this element): --prev, --next
 */
class SQuoteSlider extends HTMLElement {
  #ac;
  #track;

  connectedCallback() {
    this.#track = this.querySelector('[data-slider-track]');
    if (!this.#track) return;
    this.#ac = new AbortController();
    const signal = this.#ac.signal;

    this.addEventListener(
      'command',
      (event) => {
        if (event.command === '--prev') this.#step(-1);
        if (event.command === '--next') this.#step(1);
      },
      { signal }
    );
    this.#track.addEventListener('scroll', () => this.#updateButtons(), { signal, passive: true });
    window.addEventListener('resize', () => this.#updateButtons(), { signal, passive: true });
    this.#updateButtons();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #step(direction) {
    const card = this.#track.firstElementChild;
    if (!card) return;
    const gap = parseFloat(getComputedStyle(this.#track).columnGap) || 0;
    const rtl = getComputedStyle(this).direction === 'rtl';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollBy({ left: direction * (rtl ? -1 : 1) * (card.offsetWidth + gap), behavior: reduce ? 'auto' : 'smooth' });
  }

  #updateButtons() {
    const max = this.#track.scrollWidth - this.#track.clientWidth;
    const position = Math.abs(this.#track.scrollLeft);
    const prev = this.querySelector('[command="--prev"]');
    const next = this.querySelector('[command="--next"]');
    if (prev) prev.disabled = position <= 1;
    if (next) next.disabled = position >= max - 1;
    const nav = this.querySelector('[data-slider-nav]');
    if (nav) nav.hidden = max <= 1;
  }
}

if (!customElements.get('s-quote-slider')) customElements.define('s-quote-slider', SQuoteSlider);
